export default __webpack_public_path__ + "static/media/winner2.c069cf69.svg";